import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "../../src/Styles/Pages/singlepage.scss";
import Button from "../../src/Resources/Forms/Button";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { _capitalizeText } from "../../src/Utils/helpers";
import withScreenType from "../../src/HOC/withSceenType";
// import { _capitalizeText } from "../src/Utils/helpers";
// import withScreenType from "../../src/HOC/withSceenType";

class SinglePage extends Component {
	constructor(props) {
		super(props);
		this.headerRef = React.createRef();
		this.footerRef = React.createRef();
		this.state = {
			height: "",
			showContent: false,
		};
	}

	componentDidMount() {
		this.hideHeaderText();
		setTimeout(() => {
			this.setState({ showContent: true }, () => {
				if (this.props.isFixedHeight) {
					this.getHeight();
					window.addEventListener("resize", this.reCalculateHeight);
				}
			});
		}, 10);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.buttonText !== this.props.buttonText) {
			if (this.props.isFixedHeight) {
				this.getHeight();
				window.addEventListener("resize", this.reCalculateHeight);
			}
		}
		if (prevProps.screenType !== this.props.screenType) {
			this.hideHeaderText();
		}
	}

	componentWillUnmount() {
		document.removeEventListener("resize", this.reCalculateHeight, false);
		if (document.querySelector(".bo-header")) {
			document.querySelector(".bo-header").style.opacity = 1;
		}
		// fix Warning: Can't perform a React state update on an unmounted component
		this.setState = (state, callback) => {
			return;
		};
	}

	hideHeaderText = () => {
		if (document.querySelector(".bo-header")) {
			const isMobile = this.props.screenType === "mobile";

			document.querySelector(".bo-header").style.opacity = isMobile ? 0 : 1;
		}
	};

	render() {
		const isDesktop = this.props.screenType !== "mobile";
		return (
			<TransitionGroup component={null}>
				{this.state.showContent && (
					<CSSTransition classNames="single-page-component-anim" timeout={300}>
						<div
							className="single-page-component"
							style={{
								maxWidth: this.props.width || "600px",
								margin: this.props.margin || "",
							}}
						>
							<div className="single-page-component-card">
								<div
									className={`single-page-component-card-header ${
										this.props.fixedHeader && !this.props.isFixedHeight
											? "sticky-header"
											: ""
									}`}
									ref={this.headerRef}
									style={this.props.styleHeader}
								>
									{!this.props.noBack && (
										<>
											<img
												src="Images/dark-back.svg"
												alt=""
												onClick={() =>
													this.props.backAction
														? this.props.backAction()
														: this.props.history.goBack()
												}
												className="no-print"
											/>
										</>
									)}

									{this.props.showMainHeaderMenuIcon &&
										this.props.screenType === "mobile" && (
											<img
												src="Images/menu.svg"
												alt=""
												onClick={this.props.openSidebar}
												className="no-print"
												style={{ width: "23px", height: "19px" }}
											/>
										)}

									<div>
										{!this.props.preserveHeadingText
											? _capitalizeText(this.props.heading)
											: this.props.heading}
									</div>
									{this.props.headerButtonText &&
										this.props.headerButtonAction && (
											<div
												style={{ margin: "0 0 0 auto" }}
												className="no-print"
											>
												<Button
													type={this.props.headerButtonType || "primary"}
													text={this.props.headerButtonText}
													loading={this.props.headerButtonLoading}
													onClick={this.props.headerButtonAction}
													disabled={this.props.headerButtonDisabled}
													noMargin={true}
													size={"small"}
												/>
											</div>
										)}

									{this.props.headersButtons && (
										<div style={{ margin: "0 0 0 auto" }} className="no-print">
											{this.props.headersButtonsField}
										</div>
									)}
								</div>
								<div
									className="single-page-component-card-body"
									style={{
										height: this.props.isFixedHeight
											? isDesktop
												? this.props.buttonText && this.props.buttonAction
													? "calc(100vh - 280px)"
													: "calc(100vh - 220px)"
												: this.state.height
											: window.screen.width < 1125
											? "calc(100vh - 70px)"
											: "",
										background: this.props.backgroundColor
											? this.props.backgroundColor
											: "",
										overflowY:
											this.props.hideOverflow && isDesktop
												? "hidden"
												: !this.props.isFixedHeight && isDesktop
												? "initial"
												: "auto",
									}}
								>
									{this.props.children}
								</div>
								{this.props.buttonText && this.props.buttonAction && (
									<div
										style={{
											display: this.props.flexBetweenButtons ? "" : "flex",
											width: this.props.flexBetweenButtons ? "" : "100%",
											padding: this.props.flexBetweenButtons
												? "10px"
												: "10px 0",
										}}
										className="single-page-component-card-footer no-print"
										ref={this.footerRef}
									>
										{!this.props.hideButton ? (
											<div
												className={`${
													this.props.displaySecondaryButton
														? "action-container"
														: ""
												}`}
											>
												{this.props.displaySecondaryButton && (
													<div style={{ marginRight: "16px" }}>
														<Button
															type={this.props.secondaryButtonType || "default"}
															text={this.props.secondaryButtonText}
															loading={this.props.secondaryButtonLoading}
															onClick={this.props.secondaryButtonAction}
															disabled={
																this.props.secondaryButtonDisabled ||
																this.props.buttonLoading
															}
															noMargin={true}
														></Button>
													</div>
												)}
												<Button
													type={this.props.buttonType || "primary"}
													text={this.props.buttonText}
													loading={this.props.buttonLoading}
													onClick={
														this.props.isFormSubmit
															? null
															: this.props.buttonAction
													}
													disabled={this.props.buttonDisabled}
													formId={this.props.formId}
													noMargin={true}
												/>
											</div>
										) : (
											<div style={{ height: "40px" }} />
										)}
										{this.props.errorMsg && (
											<p
												style={{
													color: "rgb(255, 5, 5)",
													margin: "5px",
													opacity: "0.7",
												}}
											>
												{this.props.errorMsg}
											</p>
										)}
									</div>
								)}
							</div>
						</div>
					</CSSTransition>
				)}
			</TransitionGroup>
		);
	}

	getHeight = () => {
		let fixedHeights = 0;
		let heightToUse;
		if (this.headerRef.current) {
			fixedHeights =
				fixedHeights + this.headerRef.current.getBoundingClientRect().height;
		}
		if (this.footerRef.current) {
			fixedHeights =
				fixedHeights + this.footerRef.current.getBoundingClientRect().height;
		}
		if (this.props.screenType === "mobile") {
			fixedHeights = fixedHeights + 45;
			heightToUse = window.innerHeight;
		} else {
			fixedHeights = fixedHeights + 250;
			heightToUse = window.outerHeight;
		}
		if (!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)) {
			heightToUse = window.innerHeight;
		}

		this.setState({ height: `${heightToUse - fixedHeights}px` }, () => {});
	};

	reCalculateHeight = () => {
		this.getHeight();
	};
}

export default withRouter(withScreenType(SinglePage));
